import { ALERT_ACTION } from '~/Constants/Actions.constants';
import { INeoAction } from '../../Actions.interface';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export type AlertsVisibilityTypeState = { [key: string]: boolean };

const INITIAL: AlertsVisibilityTypeState = {};

const alertsVisibilityReducer = (
  state: AlertsVisibilityTypeState = INITIAL,
  action: INeoAction,
): AlertsVisibilityTypeState => {
  const { payload, name } = action;

  if (name === ALERT_ACTION.UPDATE_ALERT_VISIBILITY) {
    return { ...state, [payload.key]: payload.value };
  }

  return state;
};

const alertsReducerPersistConfig = {
  key: 'alerts-visibility',
  storage,
  blacklist: ['recovery'],
};

export default persistReducer(alertsReducerPersistConfig, alertsVisibilityReducer);
